module.exports = __webpack_public_path__ + "media/maps-markers/purple-pin-4198684d.svg";